import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AppRoute from './routes/AppRoute';
import Snackbar from './components/common/SnackbarMessage';
import CommonDrawerComponent from './components/drawer';
import CommonDialogComponent from './components/dialog';
import useDisableRightClick from './hooks/useDisableRightClick';
import { ISLive } from './utils/base-urls';

const App = () => {
    useDisableRightClick(ISLive); 

    return (<>
        <Router>
            <Routes>
                <Route path='*' element={<AppRoute />} />
            </Routes>
            <CommonDrawerComponent />
            <CommonDialogComponent />
        </Router>
        <Snackbar />
    </>)
}

export default App;